<app-offcanvas-sheet
  [visible]="visible"
  [title]="title"
  (closeCanvas)="onClose()"
  (save)="onSave()">

  <!-- User mode -->
  <ng-container *ngIf="mode === 'user'">
    <div class="form-group-mobile">
      <label>Email</label>
      <input type="email" class="form-control" [(ngModel)]="editData.email" placeholder="user@example.com" />
    </div>
    <div class="form-group-mobile">
      <label>First Name</label>
      <input type="text" class="form-control" [(ngModel)]="editData.firstName" placeholder="First name" />
    </div>
    <div class="form-group-mobile">
      <label>Last Name</label>
      <input type="text" class="form-control" [(ngModel)]="editData.lastName" placeholder="Last name" />
    </div>
    <div class="form-group-mobile" *ngIf="!isEditing">
      <label>Password</label>
      <input type="password" class="form-control" [(ngModel)]="editData.password" placeholder="Temporary password" />
    </div>
    <div class="form-group-mobile">
      <label>Role</label>
      <app-single-select-dropdown
        [options]="adminRoleOptions"
        placeholder="Select role"
        [selectedValue]="selectedRoleValue"
        (selectedValueChange)="onRoleSelected($event)">
      </app-single-select-dropdown>
    </div>
    <div class="form-group-mobile">
      <label>Status</label>
      <div class="form-check form-switch mt-1">
        <input class="form-check-input" type="checkbox" id="offcanvasActiveToggle"
          [(ngModel)]="editData.isActive" />
        <label class="form-check-label" for="offcanvasActiveToggle">
          {{ editData.isActive ? 'Active' : 'Inactive' }}
        </label>
      </div>
    </div>
  </ng-container>

  <!-- Role mode -->
  <ng-container *ngIf="mode === 'role'">
    <div class="form-group-mobile">
      <label>Role Name</label>
      <input type="text" class="form-control" [(ngModel)]="editData.roleName" placeholder="Role name" />
    </div>
    <div class="form-group-mobile">
      <label>Description</label>
      <textarea class="form-control" rows="3" [(ngModel)]="editData.description" placeholder="Optional description"></textarea>
    </div>
  </ng-container>

  <!-- Category mode -->
  <ng-container *ngIf="mode === 'category'">
    <div class="form-group-mobile">
      <label>Category Name</label>
      <input type="text" class="form-control" [(ngModel)]="editData.categoryName" placeholder="Category name" />
    </div>
  </ng-container>

</app-offcanvas-sheet>
